import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axios from 'axios';

const LocationDropdown = ({ selectedLocation, onChange }) => {
  const [cities, setCities] = useState([]);
  const [defaultLocation, setDefaultLocation] = useState('');
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    // Load default location from localStorage
    const savedLocation = localStorage.getItem('selectedLocation');
    setDefaultLocation(savedLocation || 'Chennai'); // Fallback to Chennai if no saved location

    // Fetch cities from API
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API2_URL}/getavailablecities`);
        setCities(response.data.cities || []);
      } catch (err) {
        console.error('Error fetching cities:', err);
      }
    };

    fetchCities();
  }, []);

  const handleLocationChange = (value) => {
    localStorage.setItem('selectedLocation', value); // Update localStorage
    onChange(value); // Call parent onChange
    navigate(`/explore/${value}`); // Redirect to the selected location
  };

  return (
    <div className="relative">
      <select
        value={selectedLocation || defaultLocation}
        onChange={(e) => handleLocationChange(e.target.value)}
        className="appearance-none text-gray-900 font-medium bg-transparent focus:outline-none border-none cursor-pointer text-sm pr-8"
      >
        {cities.map((city, index) => (
          <option key={index} value={city}>
            {city}
          </option>
        ))}
      </select>
      <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none pr-2">
        <svg
          className="w-4 h-4 text-gray-900"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </span>
    </div>
  );
};

export default LocationDropdown;
